var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { createIntl, createIntlCache } from 'react-intl';
import axios from 'axios';
const cache = createIntlCache();
export const ReactIntl = (lng, ns) => __awaiter(void 0, void 0, void 0, function* () {
    let messages = {};
    try {
        messages = (yield axios.get(`https://assets.designs.ai/locales/${lng}/${ns}.json`)).data;
    }
    catch (error) {
        console.error(error);
    }
    return createIntl({
        // Locale of the application
        locale: lng,
        // Locale of the fallback defaultMessage
        defaultLocale: 'en',
        messages
    }, cache);
});
export const InitIntl = () => {
    return createIntl({
        // Locale of the application
        locale: 'en',
        // Locale of the fallback defaultMessage
        defaultLocale: 'en',
        messages: {}
    }, cache);
};
//# sourceMappingURL=intel.js.map